import React from 'react';
import { Link } from 'react-router-dom';

const Government = () => (
  <>
    {/* Hero */}
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">Government Services</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>GSA Contract Holder — Serving Federal, State & Local Agencies</p>
      </div>
    </section>

    {/* GSA Section */}
    <section className="py-5 bg-white">
      <div className="container py-4">
        <div className="text-center mb-5">
          <p className="fw-bold text-uppercase text-primary fs-5 mb-3">General Services Administration</p>
          <img
            src="https://www.egbsystems.com/wp-content/uploads/2020/07/cropped-gsa-logo-e1593693272211.png"
            alt="GSA Contract"
            style={{ maxHeight: 120, objectFit: 'contain' }}
            className="mb-3"
          />
          <h2 className="fw-bold">GSA Contract Holder</h2>
        </div>

        <div className="row justify-content-center">
          <div className="col-12 col-lg-9">
            <p className="text-muted fs-5 mb-4">
              <strong>EGB has been awarded (GSA) General Services Administration;</strong> General Purpose Commercial Information Technology Equipment, Software and Services Schedule. This schedule extends our strategic Information Technology services to meet the needs of local, state and federal government agencies.
            </p>
            <p className="text-muted fs-5 mb-5">
              We map entire spectrum of information technology needs and provide state-of-the-art services to meet GSA requirements with competitive rates. Our exceptional services are eligible for government requirement for access to sensitive information.
            </p>
          </div>
        </div>

        {/* Schedule 70 */}
        <div className="card border-0 shadow-sm rounded-4 mb-4">
          <div className="card-body p-4">
            <h5 className="fw-bold text-warning text-uppercase mb-3">
              Federal Supply Schedule 70 — Information Technology Services
            </h5>
            <p className="text-muted mb-2">Approved rates in all 50 states</p>
            <a
              href="https://www.egbsystems.com/wp-content/uploads/2020/09/EGBCatalog70_gsa.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary fw-semibold"
            >
              Contact number: GS-35F-0157V &nbsp;|&nbsp; Contract Period: 1/8/09 through 1/7/14
            </a>
            <p className="text-muted small mt-2">* Click on the Contract Number to view our price catalog</p>
          </div>
        </div>

        {/* Schedule 541 */}
        <div className="card border-0 shadow-sm rounded-4 mb-5">
          <div className="card-body p-4">
            <h5 className="fw-bold text-warning text-uppercase mb-1">
              Federal Supply Schedule 541 — Advertising & Integrated Marketing Solution
            </h5>
            <p className="text-muted small mb-2">(Web Based Marketing Services, Commercial Art and Graphic Design)</p>
            <p className="text-muted mb-2">Approved rates in all 50 states</p>
            <a
              href="https://www.egbsystems.com/wp-content/uploads/2020/09/EGBCatalog541_gsa.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary fw-semibold"
            >
              Contract Number: GS-07F-0517V &nbsp;|&nbsp; Contract Period: 9/10/09 through 9/9/14
            </a>
            <p className="text-muted small mt-2">* Click on the Contract Number to view our price catalog</p>
          </div>
        </div>

        {/* Government IT Services */}
        <h3 className="fw-bold text-center mb-4">Government IT Services</h3>
        <div className="row g-4">
          {[
            { icon: '🔒', title: 'Cybersecurity & Compliance', desc: 'FISMA, FedRAMP, NIST compliance and security audits for government agencies.' },
            { icon: '☁️', title: 'Cloud Migration', desc: 'Secure migration to FedRAMP-authorized cloud platforms (AWS GovCloud, Azure Government).' },
            { icon: '📊', title: 'Data Analytics', desc: 'Business intelligence and data management solutions for government decision-making.' },
            { icon: '💻', title: 'Custom Software', desc: 'Tailored applications for government workflows and citizen services.' },
            { icon: '🖥️', title: 'IT Infrastructure', desc: 'Network setup, maintenance, and managed services for government facilities.' },
            { icon: '📋', title: 'Back Office Support', desc: 'Data processing and administrative support services.' },
            { icon: '🧠', title: 'AI & Machine Learning', desc: 'AI-powered automation, predictive analytics, and intelligent document processing for government operations.' },
            { icon: '🤖', title: 'AI-Powered Chatbots', desc: 'Intelligent virtual assistants for citizen services, reducing call center load 24/7.' },
            { icon: '👁️', title: 'Computer Vision & Surveillance', desc: 'AI-based image recognition and video analytics for public safety and border security.' },
            { icon: '📡', title: 'IoT & Smart Infrastructure', desc: 'Connected sensors and smart city solutions for traffic, utilities, and public services.' },
            { icon: '🛡️', title: 'AI Cybersecurity', desc: 'AI-driven threat detection, anomaly detection, and automated incident response.' },
            { icon: '📜', title: 'Robotic Process Automation', desc: 'RPA bots to automate repetitive government processes — permits, forms, and compliance reporting.' },
            { icon: '🗂️', title: 'Digital Records Management', desc: 'AI-powered document classification, archiving, and retrieval for government records.' },
            { icon: '🌐', title: 'E-Government Portals', desc: 'Citizen-facing web portals with AI search, accessibility compliance, and multilingual support.' },
            { icon: '📈', title: 'Predictive Analytics', desc: 'Forecast resource needs, budget planning, and risk assessment using AI models.' },
            { icon: '🔗', title: 'Blockchain for Government', desc: 'Secure, transparent record-keeping for contracts, voting systems, and identity management.' },
          ].map((s, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-4">
              <div className="card border-0 shadow-sm h-100 p-3">
                <div style={{ fontSize: 36 }} className="mb-2">{s.icon}</div>
                <h6 className="fw-bold">{s.title}</h6>
                <p className="text-muted small mb-0">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5">
          <Link to="/contact" className="btn btn-primary btn-lg px-5">Request Information →</Link>
        </div>
      </div>
    </section>
  </>
);

export default Government;
